// services/track/trackVideoEvent.ts
import { trackApiInstance, handleTrackApiError } from "./trackApiInstance";
import { AxiosError } from "axios";

export interface TrackVideoPayload {
  token: string;
  privatetoken: string;
  userid: number;
  videoid: string;
  eventtype: string;
  timestamp: number;
  course: string;
  database: string;
  timecreated: number;
}

export const trackVideoEvent = async (payload: TrackVideoPayload) => {
  try {
    const response = await trackApiInstance.post("/track-video", payload);
    return response.data;
  } catch (error) {
    return handleTrackApiError(error as AxiosError);
  }
};

export const getTrackVideo = async (payload: any) => {
  try {
    const response = await trackApiInstance.post("get-track-video", payload);
    return response.data;
  } catch (error) {
    return handleTrackApiError(error as AxiosError);
  }
}

// export const 
